// Content for Śrīmad-Bhāgavatam 1.5.15 - The Great Disturbance

import type { TopicContent } from '../types';

const content: TopicContent = {
    primarySloka: {
        reference: 'Śrīmad-Bhāgavatam 1.5.15',
        sloka: `jugupsitaṁ dharma-kṛte 'nuśāsataḥ
svabhāva-raktasya mahān vyatikramaḥ |
yad-vākyato dharma itītaraḥ sthito
na manyate tasya nivāraṇaṁ janaḥ ||`,
        translation:
            'You have created a great disturbance (<strong>mahān vyatikramaḥ</strong>) by teaching a condemned subject (<strong>jugupsitam anuśāsataḥ</strong>) to people attached to material enjoyment (<strong>svabhāva-raktasya</strong>) in order to make them accept dharma (<strong>dharma-kṛte</strong>). Thinking that what you have taught is real dharma (<strong>yat-vākyataḥ dharmaḥ iti</strong>), they do not consider giving it up (<strong>itaraḥ sthitaḥ na manyate tasya nivāraṇam janaḥ</strong>).',
    },
    blocks: [
        {
            type: 'text',
            content:
                '<strong>“I wrote the Mahābhārata and other works so that people could hear the glories of the Lord, but I have first presented material happiness in these works in order to promote scriptures to materialistic persons who do not want <em>bhakti</em>.</strong> But that is not my real intention. The proof is Vidura’s words:',
        },
        {
            type: 'sloka',
            sloka: {
                reference: 'Śrīmad-Bhāgavatam 3.5.12',
                sloka: `munir vivakṣur bhagavad-guṇānāṁ sakhāpi te bhāratam āha kṛṣṇaḥ |
yasminn nṛṇāṁ grāmya-sukhānuvādair matir gṛhītān hareḥ kathāyām ||`,
                translation:
                    "O sage! Your friend Vedavyāsa desiring to describe the qualities of the Lord, wrote Mahābhārata. In that work he attracted men's attention to topics of the Lord through topics about material happiness.",
            },
        },
        {
            type: 'text',
            content:
                'That is true. As Vidura said, in order to make people accept worship of the Lord (<em>dharma-kṛte</em>) you have taught what is condemned, <em>karma</em> (jugupsitam).<br /><br />A great disturbance has come about for materialistic people who are attached to enjoy from impressions arising for sense objects (<em>svabhāva-raktasya</em>) because you have taught material <em>dharma</em>. But though your intention was to help them, you have actually injured them. How?<br /><br /><strong>Because materially minded men (<em>prākṛtaḥ</em>) ascertaining what you explained to be the correct path (<em>dharma iti</em>)—thinking that it is not a fault to offer meat to the <em>devatās</em> and <em>pitṛs</em>, do not consider giving up that path, and do not consider what is actually to be done: <em>sarva-dharmān parityajya mām ekaṁ śaraṇam vraja</em>.</strong><br /><br />They think that this statement is not part of the path you have outlined for enjoyment. Bhaṭṭa has said the following in relation to a different topic:',
        },
        {
            type: 'sloka',
            sloka: {
                reference: 'Bhaṭṭa',
                sloka: `tatraivaṁ śakyate vaktuṁ
ye'nye paṅgv-ādayo narāḥ |
gṛhasthatvaṁ na śakyante
kartuṁ teṣām ayaṁ vidhiḥ ||
naiṣṭhika-brahmacaryaṁ vā
parivrājakatāthavā |
tair avaśyaṁ gṛhītavyā
tenādāv etad ucyate ||`,
                translation:
                    'It should be said that this instruction is for those who cannot follow household life such as disabled persons. Such persons only must take vows of permanent brahmacarya or sannyāsa. Thus this is explained in the beginning.',
            },
        },
    ],
};

export default content;